import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuth, isSuperadminRole } from "@/lib/auth/AuthContext";

// Session 16: Loading-State respektieren. Ohne diesen Guard rendert
// useIsSuperadmin() fuer einen Tick `false` (waehrend AuthContext noch
// "loading" ist) und wirft den User auf "/" — sichtbar bei Direkt-URL-
// Aufrufen wie /system/selftests im neuen Tab.

export function RequireSuperadmin({ children }: { children: ReactNode }) {
  const { status, user } = useAuth();
  if (status === "loading") return null;
  if (!user || !isSuperadminRole(user.role)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
